// Jedno źródło prawdy o licencjach, uprawnieniach i przedmiotach egzaminacyjnych.
// Te same wartości obowiązują po stronie API (/projekty/egzaminy/app.py,
// stałe PILOTUJE_LICENCJE i PILOTUJE_ARKUSZE) - przy zmianie poprawiaj oba miejsca.
//
// Liczby pytań i czasy dla PPL(A)/LAPL(A) odpowiadają tabeli Krajowego Banku
// Pytań publikowanej przez Lotniczą Komisję Egzaminacyjną ULC. To parametry
// organizacyjne, które ULC potrafi zmienić komunikatem - dlatego każda strona,
// która je pokazuje, odsyła do aktualnego komunikatu LKE.

/** Próg zaliczenia w procentach - taki sam dla wszystkich egzaminów tu opisanych. */
export const PROG_PROCENT = 75;

/* ------------------------------------------------------------------ */
/* Przedmioty                                                          */
/* ------------------------------------------------------------------ */
/* Kolejność = kolejność w nawigacji trybu nauki.
   `rodzina` pozwala oddzielić przedmioty załogowe od dronowych - w nawigacji
   i w sitemapie nie chcemy ich mieszać. */
export const PRZEDMIOTY = [
  {
    slug: 'prawo-lotnicze',
    nazwa: 'Prawo lotnicze',
    rodzina: 'zalogowe',
    opis:
      'Ustawa Prawo lotnicze, Part-FCL, SERA, klasyfikacja przestrzeni powietrznej, licencje i uprawnienia, dokumenty statku powietrznego, NOTAM i AIP.',
  },
  {
    slug: 'ogolna-wiedza-o-statku-powietrznym',
    nazwa: 'Ogólna wiedza o statku powietrznym',
    rodzina: 'zalogowe',
    opis:
      'Płatowiec, zespół napędowy, instalacje pokładowe, przyrządy pilotażowo-nawigacyjne, układ elektryczny, obsługa i ograniczenia eksploatacyjne.',
  },
  {
    slug: 'osiagi-i-planowanie-lotu',
    nazwa: 'Osiągi i planowanie lotu',
    rodzina: 'zalogowe',
    opis:
      'Masa i wyważenie, długość startu i lądowania, wpływ wysokości gęstościowej, zużycie paliwa, plan lotu i nawigacyjny plan lotu.',
  },
  {
    slug: 'czlowiek-mozliwosci-i-ograniczenia',
    nazwa: 'Człowiek - możliwości i ograniczenia',
    rodzina: 'zalogowe',
    opis:
      'Fizjologia lotu, hipoksja, hiperwentylacja, dezorientacja przestrzenna, wzrok i słuch, zmęczenie, stres, podejmowanie decyzji i orzeczenie lekarskie.',
  },
  {
    slug: 'meteorologia',
    nazwa: 'Meteorologia',
    rodzina: 'zalogowe',
    opis:
      'Atmosfera, ciśnienie i wysokościomierz, wiatr, chmury, fronty, oblodzenie, turbulencja, burze, mgła oraz depesze METAR, TAF i SIGMET.',
  },
  {
    slug: 'nawigacja',
    nazwa: 'Nawigacja',
    rodzina: 'zalogowe',
    opis:
      'Mapa lotnicza, kursy i poprawki, deklinacja i dewiacja, trójkąt nawigacyjny, nawigacja zliczeniowa, GNSS oraz nawigacja radiowa VOR, NDB i DME.',
  },
  {
    slug: 'procedury-operacyjne',
    nazwa: 'Procedury operacyjne',
    rodzina: 'zalogowe',
    opis:
      'Procedury lotniskowe i kręgu nadlotniskowego, sytuacje niebezpieczne, turbulencja w śladzie aerodynamicznym, wiatr uskokowy, przymusowe lądowanie, zgłaszanie zdarzeń lotniczych.',
  },
  {
    slug: 'zasady-lotu',
    nazwa: 'Zasady lotu',
    rodzina: 'zalogowe',
    opis:
      'Siła nośna i opór, profil skrzydła, przeciągnięcie i korkociąg, stateczność i sterowność, obciążenia w zakręcie, obwiednia obciążeń, prędkości charakterystyczne.',
  },
  {
    slug: 'lacznosc',
    nazwa: 'Łączność',
    rodzina: 'zalogowe',
    opis:
      'Frazeologia VFR po polsku i angielsku, alfabet fonetyczny, procedury łączności z FIS, TWR i ATIS, utrata łączności, sygnały i komunikaty w niebezpieczeństwie.',
  },

  /* ---- drony (rozporządzenia 2019/945 i 2019/947) ---- */
  {
    slug: 'dron-przepisy-lotnicze',
    nazwa: 'Przepisy lotnicze dla BSP',
    rodzina: 'bsp',
    opis:
      'Rozporządzenia 2019/945 i 2019/947, kategorie operacji, podkategorie A1, A2 i A3, klasy C0-C4, rejestracja operatora, obowiązki pilota bezzałogowca.',
  },
  {
    slug: 'dron-przestrzen-powietrzna',
    nazwa: 'Ograniczenia przestrzeni powietrznej',
    rodzina: 'bsp',
    opis:
      'Strefy geograficzne, DRA-R, DRA-P i DRA-I, CTR i ATZ, aplikacja DroneRadar i system PansaUTM, zgody na loty i warunki ich wydania.',
  },
  {
    slug: 'dron-bezpieczenstwo-i-procedury',
    nazwa: 'Bezpieczeństwo lotu i procedury operacyjne',
    rodzina: 'bsp',
    opis:
      'Przygotowanie do lotu, VLOS, wysokość 120 m, odległości od osób postronnych, sytuacje awaryjne, zgłaszanie zdarzeń, ubezpieczenie OC.',
  },
  {
    slug: 'dron-wiedza-o-uas',
    nazwa: 'Ogólna wiedza o systemie bezzałogowym',
    rodzina: 'bsp',
    opis:
      'Budowa bezzałogowca, akumulatory LiPo, łącze radiowe i jego utrata, kompas i GNSS, masa startowa, oznakowanie CE i etykieta klasy.',
  },
  {
    slug: 'dron-czlowiek-i-prawo',
    nazwa: 'Człowiek, prywatność i ochrona',
    rodzina: 'bsp',
    opis:
      'Ograniczenia możliwości człowieka, RODO i nagrywanie obrazu, ochrona przed dostępem osób niepowołanych, odpowiedzialność za szkody.',
  },
  {
    slug: 'dron-meteo-i-osiagi',
    nazwa: 'Meteorologia i osiągi bezzałogowca',
    rodzina: 'bsp',
    opis:
      'Wiatr i podmuchy, temperatura i wpływ na akumulator, opady i oblodzenie, zasięg i czas lotu, środki ograniczające ryzyko na ziemi. Zakres egzaminu A2.',
  },
];

export const PRZEDMIOT_PO_SLUGU = Object.fromEntries(PRZEDMIOTY.map(p => [p.slug, p]));

/* ------------------------------------------------------------------ */
/* Arkusze egzaminacyjne                                               */
/* ------------------------------------------------------------------ */
/* Dla PPL(A) i LAPL(A) egzamin teoretyczny to dziewięć osobnych testów -
   każdy z własną liczbą pytań i własnym limitem czasu, każdy zaliczany
   niezależnie. To zasadnicza różnica wobec jednego zbiorczego testu i dlatego
   symulator egzaminu jest tu uruchamiany per przedmiot, a nie per licencja. */
const ARKUSZE_PPL = [
  { grupa: 'prawo-lotnicze', pytan: 28, minut: 45 },
  { grupa: 'ogolna-wiedza-o-statku-powietrznym', pytan: 16, minut: 30 },
  { grupa: 'osiagi-i-planowanie-lotu', pytan: 20, minut: 60 },
  { grupa: 'czlowiek-mozliwosci-i-ograniczenia', pytan: 12, minut: 30 },
  { grupa: 'meteorologia', pytan: 12, minut: 30 },
  { grupa: 'nawigacja', pytan: 24, minut: 60 },
  { grupa: 'procedury-operacyjne', pytan: 12, minut: 30 },
  { grupa: 'zasady-lotu', pytan: 16, minut: 45 },
  { grupa: 'lacznosc', pytan: 12, minut: 30 },
];

/* Świadectwo kwalifikacji pilota samolotu ultralekkiego zdaje się jako jeden
   test obejmujący wszystkie przedmioty szkolenia. Rozkład poniżej odwzorowuje
   proporcje programu szkolenia teoretycznego. */
const ARKUSZ_UL = { pytan: 35, minut: 60 };
const ROZKLAD_UL = {
  'prawo-lotnicze': 8,
  'zasady-lotu': 5,
  'ogolna-wiedza-o-statku-powietrznym': 5,
  meteorologia: 4,
  nawigacja: 4,
  'procedury-operacyjne': 3,
  'osiagi-i-planowanie-lotu': 3,
  'czlowiek-mozliwosci-i-ograniczenia': 2,
  lacznosc: 1,
};

const ROZKLAD_A1A3 = {
  'dron-przepisy-lotnicze': 9,
  'dron-przestrzen-powietrzna': 8,
  'dron-bezpieczenstwo-i-procedury': 9,
  'dron-wiedza-o-uas': 8,
  'dron-czlowiek-i-prawo': 6,
};

const ROZKLAD_A2 = {
  'dron-przepisy-lotnicze': 6,
  'dron-przestrzen-powietrzna': 5,
  'dron-bezpieczenstwo-i-procedury': 7,
  'dron-meteo-i-osiagi': 7,
  'dron-wiedza-o-uas': 5,
};

/* ------------------------------------------------------------------ */
/* Licencje i uprawnienia                                              */
/* ------------------------------------------------------------------ */
export const LICENCJE = [
  {
    slug: 'ppl-a',
    path: '/licencja-ppl-a',
    nazwa: 'PPL(A)',
    pelna: 'Licencja pilota turystycznego samolotowego',
    dopelniacz: 'licencji PPL(A)',
    krotko: 'PPL(A)',
    rodzina: 'zalogowe',
    organ: 'Urząd Lotnictwa Cywilnego (Lotnicza Komisja Egzaminacyjna)',
    wiek: 17,
    wiekSamodzielny: 16,
    uprawnia:
      'Wykonywanie lotów w charakterze pilota dowódcy na samolotach w operacjach niezarobkowych. Nie pozwala na odpłatne przewożenie pasażerów ani ładunków.',
    tryb: 'przedmioty',
    arkusze: ARKUSZE_PPL,
    egzaminOpis:
      'Dziewięć osobnych testów, każdy zaliczany niezależnie przy 75 procentach poprawnych odpowiedzi.',
    naukaPrzedmioty: ARKUSZE_PPL.map(a => a.grupa),
  },
  {
    slug: 'lapl-a',
    path: '/licencja-lapl-a',
    nazwa: 'LAPL(A)',
    pelna: 'Licencja pilota lekkich samolotów',
    dopelniacz: 'licencji LAPL(A)',
    krotko: 'LAPL(A)',
    rodzina: 'zalogowe',
    organ: 'Urząd Lotnictwa Cywilnego (Lotnicza Komisja Egzaminacyjna)',
    wiek: 17,
    wiekSamodzielny: 16,
    uprawnia:
      'Loty w charakterze pilota dowódcy na samolotach o maksymalnej masie startowej do 2000 kg, z maksymalnie trzema pasażerami na pokładzie. Licencja ważna wyłącznie w państwach EASA.',
    tryb: 'przedmioty',
    arkusze: ARKUSZE_PPL,
    egzaminOpis:
      'Zakres przedmiotów jest wspólny z PPL(A), a testy zdaje się w tym samym trybie i przy tym samym progu 75 procent.',
    naukaPrzedmioty: ARKUSZE_PPL.map(a => a.grupa),
  },
  {
    slug: 'ul-uacp',
    path: '/swiadectwo-kwalifikacji-ul',
    nazwa: 'Świadectwo kwalifikacji UACP',
    pelna: 'Świadectwo kwalifikacji pilota samolotu ultralekkiego',
    dopelniacz: 'świadectwa kwalifikacji UACP',
    krotko: 'UACP',
    rodzina: 'zalogowe',
    organ: 'Urząd Lotnictwa Cywilnego',
    wiek: 16,
    wiekSamodzielny: 15,
    uprawnia:
      'Wykonywanie lotów na samolotach ultralekkich, w Polsce najczęściej z uprawnieniem podstawowym na samoloty lądowe UAP(L). To krajowe uprawnienie, a nie licencja europejska.',
    tryb: 'jeden',
    arkusz: ARKUSZ_UL,
    rozklad: ROZKLAD_UL,
    egzaminOpis:
      'Jeden test obejmujący wszystkie przedmioty szkolenia teoretycznego, zaliczany przy 75 procentach poprawnych odpowiedzi.',
    naukaPrzedmioty: Object.keys(ROZKLAD_UL),
  },
  {
    slug: 'dron-a1-a3',
    path: '/dron-a1-a3',
    nazwa: 'Dron A1/A3',
    pelna: 'Kompetencje pilota bezzałogowca w podkategoriach A1 i A3',
    dopelniacz: 'uprawnień A1/A3',
    krotko: 'A1/A3',
    rodzina: 'bsp',
    organ: 'Urząd Lotnictwa Cywilnego',
    wiek: 16,
    uprawnia:
      'Loty w kategorii otwartej w podkategoriach A1 i A3: bezzałogowcem do 250 g nad ludźmi z wyłączeniem zgromadzeń oraz cięższym sprzętem z dala od osób postronnych i zabudowy.',
    tryb: 'jeden',
    arkusz: { pytan: 40, minut: 30 },
    rozklad: ROZKLAD_A1A3,
    egzaminOpis:
      'Egzamin online na platformie ULC: 40 pytań wielokrotnego wyboru, 30 minut, próg 75 procent. Zaliczenie potwierdza się certyfikatem ważnym 5 lat.',
    naukaPrzedmioty: Object.keys(ROZKLAD_A1A3),
  },
  {
    slug: 'dron-a2',
    path: '/dron-a2',
    nazwa: 'Dron A2',
    pelna: 'Certyfikat kompetencji pilota bezzałogowca w podkategorii A2',
    dopelniacz: 'certyfikatu A2',
    krotko: 'A2',
    rodzina: 'bsp',
    organ: 'Urząd Lotnictwa Cywilnego oraz podmioty uznane przez ULC',
    wiek: 16,
    uprawnia:
      'Loty w kategorii otwartej w podkategorii A2, czyli bliżej osób postronnych i cięższym sprzętem niż pozwala A1. Wymaga wcześniejszego zaliczenia A1/A3 i samodzielnego szkolenia praktycznego.',
    tryb: 'jeden',
    arkusz: { pytan: 30, minut: 45 },
    rozklad: ROZKLAD_A2,
    egzaminOpis:
      'Dodatkowy egzamin teoretyczny prowadzony przez ULC lub podmiot uznany, zaliczany przy 75 procentach poprawnych odpowiedzi.',
    naukaPrzedmioty: Object.keys(ROZKLAD_A2),
  },
];

export const LICENCJA_PO_SLUGU = Object.fromEntries(LICENCJE.map(l => [l.slug, l]));

/** Licencje pogrupowane tak, jak pokazuje je nawigacja i strona główna. */
export const LICENCJE_ZALOGOWE = LICENCJE.filter(l => l.rodzina === 'zalogowe');
export const LICENCJE_BSP = LICENCJE.filter(l => l.rodzina === 'bsp');

/** Łączna liczba pytań w egzaminie danej licencji. */
export const pytanWEgzaminie = licencja => {
  if (!licencja) return 0;
  if (licencja.tryb === 'przedmioty') {
    return licencja.arkusze.reduce((suma, a) => suma + a.pytan, 0);
  }
  return licencja.arkusz.pytan;
};

/** Liczba poprawnych odpowiedzi potrzebna do zaliczenia arkusza o zadanej długości. */
export const progDlaArkusza = pytan => Math.ceil((pytan * PROG_PROCENT) / 100);

/** Arkusz danego przedmiotu w danej licencji - albo null, gdy przedmiotu tu nie ma. */
export const arkuszPrzedmiotu = (licencja, grupaSlug) => {
  if (!licencja) return null;
  if (licencja.tryb === 'przedmioty') {
    return licencja.arkusze.find(a => a.grupa === grupaSlug) || null;
  }
  return licencja.rozklad && licencja.rozklad[grupaSlug] ? licencja.arkusz : null;
};

/** Przedmioty danej licencji w kolejności z PRZEDMIOTY. */
export const przedmiotyLicencji = licencja => {
  if (!licencja) return [];
  const chciane = new Set(licencja.naukaPrzedmioty);
  return PRZEDMIOTY.filter(p => chciane.has(p.slug));
};

export const KLUCZE_ODPOWIEDZI = ['answerA', 'answerB', 'answerC', 'answerD'];

export const LITERY = { answerA: 'A', answerB: 'B', answerC: 'C', answerD: 'D' };

/** Klucze odpowiedzi obecne w danym pytaniu - część pytań ma trzy warianty, część cztery. */
export const kluczeOdpowiedzi = pytanie =>
  KLUCZE_ODPOWIEDZI.filter(k => pytanie && typeof pytanie[k] === 'string' && pytanie[k].trim());
